(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maorelia-cart-actions"] && !Shopify.designMode) return;
  try {
    if (!window.__mcaBound) {
    window.__mcaBound = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-mca-cancel]');
      if (!button) return;
      if (!window.confirm('Annuler votre achat et vider votre panier ?')) return;
      button.disabled = true;
      fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          button.disabled = false;
        });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
